import { type GroupCommand, type GroupSnapshot, groupSnapshotSchema } from '@crowdex/groups';
import { apiFetch } from '@crowdex/host-kit/renderer/http';

/** A command of a group (its state, a message, pause, resume); its room's state after it. */
export async function groupCommand(
  conversation: string,
  command: GroupCommand,
  signal?: AbortSignal,
): Promise<GroupSnapshot> {
  const data = await apiFetch<unknown>(
    `/api/assistant/groups/${encodeURIComponent(conversation)}`,
    {
      method: 'POST',
      credentials: 'include',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(command),
      ...(signal === undefined ? {} : { signal }),
    },
  );
  return groupSnapshotSchema.parse(data);
}
